module.exports = __webpack_public_path__ + "static/media/2.question.1e4299e7.mp4";